import { custom } from './custom';

export const environment = {
	...custom,
	name: 'Staging',
	api_url: 'https://test-dashboard-welex.prov.bz.it/dbe',
	readylex_url: 'https://test-dashboard-welex.prov.bz.it/simplex',
	msalConfig: {
		clientId: '48370d28-add8-48e3-9ccc-3b14cac8229d',
		authority:
			'https://testb2c01siag.b2clogin.com/testb2c01siag.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_SPID',
		knownAuthorities: ['testb2c01siag.b2clogin.com'],
		scopes: [
			'https://testb2c01siag.onmicrosoft.com/bfed133a-920d-4796-ae98-8f105e6e5cb2/api.read',
		],
		extraQueryParameters: { authLogin: 'aad' },
	},
};
